import apiClient from '../axiosConfig';
import { 
  PublicInquiryControllerApi, 
  InquiryControllerApi, 
  ClientInquiry 
} from '../../apiClient';

const publicInquiryApi = new PublicInquiryControllerApi(undefined, undefined, apiClient);
const adminInquiryApi = new InquiryControllerApi(undefined, undefined, apiClient);

export const InquiryService = {
  submit: async (inquiry: ClientInquiry): Promise<void> => {
    await publicInquiryApi.create({ clientInquiry: inquiry });
  },

  getAll: async (): Promise<ClientInquiry[]> => {
    const response = await adminInquiryApi.getAll();
    return response.data;
  }
};
